module.exports = __webpack_public_path__ + "static/img/yingxiao_icon6.052bb0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/yingxiao_icon6.png
// module id = 62sV
// module chunks = 0